// removed by extract-text-webpack-plugin
module.exports = {"slidingContentPanel":"pnqeTxKf9iX2_XrCeBSRD","isActive":"_1a2eOOkNdz4206eji9t1L3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SlidingPanel/SlidingPanel.css
// module id = 1294
// module chunks = 0